module.exports = __webpack_public_path__ + "img/coin.1a49ac11.svg";